const addTeacher = () => import('@/page/user-center/teacher-groom/add-teacher.vue')
const addSuccess = () => import('@/page/user-center/teacher-groom/add-success.vue')
const lookTeacher = () => import('@/page/user-center/teacher-groom/look-teacher.vue')

export default [
  {
    path: '/addTeacher',
    name: 'addTeacher',
    component: addTeacher
  },
  {
    path: '/addSuccess',
    name: 'addSuccess',
    component: addSuccess
  },
  {
    path: '/lookTeacher',
    name: 'lookTeacher',
    component: lookTeacher
  }
]



// WEBPACK FOOTER //
// ./src/router/teacher/index.js